import { initializeCommonPageModules } from './common_page_modules';
import { init as initVehicleDetailsLightBox, onClose as crossSellLightBoxClose } from '../../../_views/vehicle_details_light_box/vehicle_details_light_box_view';

function initializeTyrePageModules(productType) {
    /**
     *
     * initialize initially visible components first
     *
     */
    initializeCommonPageModules(productType);

    const isVehicleDetailsAvailable = document.getElementById('vehicle-details');

    if (isVehicleDetailsAvailable) {
      initVehicleDetailsLightBox(isVehicleDetailsAvailable, {});
    }
}

export { initializeTyrePageModules };